import React from 'react';
import { observer } from 'mobx-react';
import { ApplicationSettingListTemplate } from 'themes/application/application-setting/pages';
import { setCurrentView } from 'core/utils';
import { ApplicationSettingListViewStore } from 'application/application-setting/stores';

@setCurrentView((rootStore) => new ApplicationSettingListViewStore(rootStore), 'listViewStore')
@observer
class ApplicationSettingList extends React.Component {
    render() {
        return <ApplicationSettingListTemplate {...this.props} />
    }
}

export default ApplicationSettingList;